"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
const validationError_1 = require("./validationError");
class Validator {
    static ok(value, message) {
        if (!value) {
            throw new validationError_1.ValidationError(message);
        }
        return value;
    }
    static notNull(value, message) {
        if (value === null) {
            throw new validationError_1.ValidationError(message);
        }
        return value;
    }
    static notNil(value, message) {
        if (value === null || value === undefined) {
            throw new validationError_1.ValidationError(message);
        }
        return value;
    }
    static all(values, message) {
        this.notNil(values, message);
        Object.entries(values).forEach(([key, value]) => {
            this.notNil(value, `expected ${key}`);
        });
        return values;
    }
}
exports.Validator = Validator;
//# sourceMappingURL=validator.js.map